import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { UpgradePlanModalComponent } from "./UpgradePlanModalComponent";
import { UpgradePlanModalUIKitComponent } from "./UpgradePlanModalUIKitComponent";

export const useUpgradePlanModal = createCompassModalSwitcher(
  UpgradePlanModalComponent,
  UpgradePlanModalUIKitComponent,
);
